import Carousel from 'react-bootstrap/Carousel';
import banner1 from "../../assets/newww/web development.jpg";
import banner2 from "../../assets/newww/logo design.jpg";
import banner3 from "../../assets/newww/digital marketing (2).jpg";
import banner4 from "../../assets/newww/branding.jpg";
import one from "../../assets/newbanner/applications-be-connected.jpg";
import two from "../../assets/newbanner/beauty-blogger-taking-photos-cosmetics.jpg";
import three from "../../assets/newbanner/businessman-holding-blank-screen-smartphone.jpg";
import four from "../../assets/newbanner/close-up-image-programer-working-his-desk-office.jpg";
import five from "../../assets/newbanner/corporate-management-strategy-solution-branding-concept.jpg";
import six from "../../assets/newbanner/dedicated-businessman-working-late-laptop-dark-office.jpg";
import seven from "../../assets/newbanner/html-css-collage-concept-with-person.jpg";
import eight from "../../assets/newbanner/html-css-collage-concept.jpg";
import nine from "../../assets/newbanner/idea-editing-program-application-interface-concept.jpg";
import ten from "../../assets/newbanner/professional-programmer-working-late-dark-office.jpg";
import one1 from "../../assets/newbanner/programming-background-with-person-working-with-codes-computer.jpg";
import one2 from "../../assets/newbanner/programming-background-with-person-working-with-codes-computer.jpg";
import one3 from "../../assets/newbanner/top-angle-view-male-web-designer-work.jpg";
import one4 from "../../assets/newbanner/top-view-drawing-pad-desk-with-laptop.jpg";
import one5 from "../../assets/newbanner/video-editor-content-creator-filming-tutorial-about-professionally-editing-footage.jpg";
import one6 from "../../assets/newbanner/video-editor-content-creator-filming-tutorial-about-professionally-editing-footage.jpg";

import './newheadeer.css';

function NewHeader() {
  const slides = [
  {
    img: banner1,
    title: (
      <>
        Building <span className="highlight">high-performance</span> websites that build your <span className="highlight">business</span>.
      </>
    ),
    btnText: "Learn More",
    btnLink: "#"
  },
  {
    img: banner4,
    title: 
    (
        <>
        Digital Campaigns That <span  className='highlight'> Speak, Engage</span> and 
         <span  className='highlight'>Convert.</span>
        </>
    ),
    btnText: "Get Started",
    btnLink: "#"
  },
  {
    img: banner2,
    title: (
      <>
        Where <span className="highlight">Brand Identity</span> Meets <span className="highlight">Business Growth</span>.
      </>
    ),
    btnText: "Discover More",
    btnLink: "#"
  },
  {
    img: banner3,
    title:(
      <>
        Designing <span className="highlight">Logos</span> That Speak Louder Than <span className="highlight">Words</span>.
      </>
    ),
    btnText: "View Portfolio",
    btnLink: "#"
  }
];

    return (
        <div style={{ marginTop: '77px' }}>
            <Carousel>
                {slides.map((slide, index) => (
                    <Carousel.Item interval={2000} key={index}>
                        <div className="carousel-container">
                            <img
                                className="d-block w-100 carousel-image"
                                src={slide.img}
                                alt={`Slide ${index + 1}`}
                            />
                            <div className="carousel-overlay"></div>

                            {/* Centered Caption */}
                            <div className="carousel-caption-center">
                                <h2>{slide.title}</h2>
                                {/* <a href={slide.btnLink} className="carousel-btn">
                                    {slide.btnText}
                                </a> */}
                            </div>
                        </div>
                    </Carousel.Item>
                ))}
            </Carousel>
        </div>
    );
}

export default NewHeader;
